/**
 * HomeGroupWA Display Homes Page JS Include
 *
 * @author Strange Animals <info@strangeanimals.com.au>
 */

// Setup carousel
$('.awards-carousel').not('.slick-initialized').slick({
    dots: false,
    prevArrow: false,
    nextArrow: false,
    infinite: true,
    autoplay: true,
    loop: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    swipe: true,
    swipeToSlide: true,
    speed: 300,
    autoplaySpeed: 4000,
    lazyLoad: true,
    slidesToShow: 1
});
